import { styled } from '@/lib/utils'

export const Grid = styled('div')(
  'flex flex-col xl:grid grid-cols-[minmax(0,_800px)_1fr] xl:items-start gap-6 pb-25'
)

export const GridColumn = styled('div')('grid gap-6')

export const Header = styled('div')('flex items-center gap-4 col-span-2')

export const DottedCanvas = styled('div')(
  'overflow-hidden shadow-inner rounded-lg shadow-sm',
  'bg-[var(--color-background)] bg-[radial-gradient(circle,_var(--color-sidebar-border)_1px,_transparent_1px)]',
  'bg-[length:16px_16px]',
  'backdrop-blur-xs border min-h-[400px]',
  'py-12 px-12 md:px-24 flex flex-col justify-center items-center gap-4',
  '[&>*]:w-full'
)

export const MetadataGrid = styled('div')(
  'grid grid-cols-[24px_1fr] gap-x-2 gap-y-4 items-center'
)
